import './active-status-text.scss';

import { type FC } from 'react';

import {
  Status,
  statusLabelMapper
} from '@/components/AdminPanel/Shared/constants';

type TProps = {
  status: boolean;
  textProps?: {
    onTrue: string;
    onFalse: string;
  };
};

const ActiveStatusText: FC<TProps> = ({ status, textProps }) => {
  if (typeof status !== 'boolean') return null;

  const {
    onTrue = statusLabelMapper[Status.active],
    onFalse = statusLabelMapper[Status.disabled]
  } = textProps ?? {};

  return (
    <span
      className={`active-status-text active-status-text--${status ? 'active' : 'disabled'}`}
    >
      {status ? onTrue : onFalse}
    </span>
  );
};

export default ActiveStatusText;
